module.exports = __webpack_public_path__ + "img/CG1_46.bd38247.png";